/**
 * Dashboard is set to FIRST_RUN, when it is opened.
 * Dashboard is set to AFTER_FIRST_RUN, when all cached reports are loaded and displayed.
 */
export enum DashboardResponsiveState {
	FIRST_RUN = 'FIRST_RUN',
	AFTER_FIRST_RUN = 'AFTER_FIRST_RUN'
}